import {
  EditButton,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const AccessLevelShow = () => (
  <Show actions={<ShowActions />} title="Access Level">
    <SimpleShowLayout>
      <TextField source="title" label="Access Title" />
      <TextField source="name" label="Access Name" />
      <TextField source="level" label="Access Level" />
    </SimpleShowLayout>
  </Show>
);
